import { openDB } from 'idb';

const DB_NAME = 'taskflow-offline';
const DB_VERSION = 1;
const TASKS_STORE = 'tasks';
const PENDING_OPS_STORE = 'pendingOps';

let dbPromise = null;

const getDb = () => {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(TASKS_STORE)) {
          db.createObjectStore(TASKS_STORE, { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains(PENDING_OPS_STORE)) {
          const store = db.createObjectStore(PENDING_OPS_STORE, {
            keyPath: 'opId',
            autoIncrement: true,
          });
          store.createIndex('timestamp', 'timestamp');
        }
      },
    });
  }
  return dbPromise;
};

// タスクのローカルキャッシュ操作
export const cacheAllTasks = async (tasks) => {
  const db = await getDb();
  const tx = db.transaction(TASKS_STORE, 'readwrite');
  await tx.store.clear();
  for (const task of tasks) {
    await tx.store.put(task);
  }
  await tx.done;
};

export const getCachedTasks = async () => {
  const db = await getDb();
  return db.getAll(TASKS_STORE);
};

export const cacheSingleTask = async (task) => {
  const db = await getDb();
  await db.put(TASKS_STORE, task);
};

export const removeCachedTask = async (taskId) => {
  const db = await getDb();
  await db.delete(TASKS_STORE, taskId);
};

// オフライン時の保留操作
export const addPendingOp = async (op) => {
  const db = await getDb();
  await db.add(PENDING_OPS_STORE, {
    ...op,
    timestamp: Date.now(),
  });
};

export const getPendingOps = async () => {
  const db = await getDb();
  return db.getAllFromIndex(PENDING_OPS_STORE, 'timestamp');
};

export const clearPendingOps = async () => {
  const db = await getDb();
  const tx = db.transaction(PENDING_OPS_STORE, 'readwrite');
  await tx.store.clear();
  await tx.done;
};

// オンライン復帰時の同期
export const isOnline = () => navigator.onLine;
